(function () {
    try {
      /* main variables */
      var debug = 0;
      var variation_name = "";
      var $;
      /* all Pure helper functions */
  
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
  
      let egstring = `<div class="eg-trustsection">
      <div class="eg-heading">
          <p>More than 200K passionate consumers gave FabuLove gifts to their partners</p>
      </div>
      <div class="eg-trust">
          <div class="eg-image"><img src="https://cdn.shopify.com/s/files/1/0593/3999/7389/files/trust_image.png?v=1730182807"></div>
          <div class="eg-text"><p>and more than 1,000 store reviews</p></div>
      </div>
      </div>`
  
      /* Variation Init */
      function init() {
        document.body.classList.add('FBPP0040');
        let targetElem = document.querySelector('.page-content .medium-up--three-fifths, .maltertech__product-thumbs');
        let mobSel = document.querySelector('.page-content .medium-up--three-fifths + div');
        let mobi_maltertech = document.querySelector('.maltertech__trustpilot-banner');
        if (!document.querySelector('.eg-trustsection')) {
          if (window.innerWidth > 767) {
            targetElem.insertAdjacentHTML('beforeend', egstring);
          } else {
            if(mobi_maltertech){
                mobi_maltertech.insertAdjacentHTML('beforeend', egstring);
            }else{
              mobSel.insertAdjacentHTML('beforeend', egstring);
            }
            
            
          }
        }
      }
      
  
      /* Initialize variation */
      waitForElement('.page-content .medium-up--three-fifths, .maltertech__product-thumbs', init, 100, 100);
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
  })();


// (function () {
//   try {
//       const debug = 0;
//       const variation_name = "";

//       const egstring = `
//       <div class="eg-trustsection">
//           <div class="eg-heading">
//               <p>More than 200K passionate consumers gave FabuLove gifts to their partners</p>
//           </div>
//           <div class="eg-trust">
//               <div class="eg-image">
//                   <img src="https://cdn.shopify.com/s/files/1/0593/3999/7389/files/trust_image.png?v=1730182807" loading="lazy">
//               </div>
//               <div class="eg-text"><p>and more than 1,000 store reviews</p></div>
//           </div>
//       </div>`;

//       function init() {
//           const bodyClass = document.body.classList;
//           const targetElem = document.querySelector('.page-content .medium-up--three-fifths, .maltertech__product-thumbs');
//           const mobSel = document.querySelector('.page-content .medium-up--three-fifths + div');
//           const mobi_maltertech = document.querySelector('.maltertech__trustpilot-banner');


//           bodyClass.add('FBPP0040');

//           if (!document.querySelector('.eg-trustsection')) {
//               if (window.innerWidth > 767) {
//                   targetElem?.insertAdjacentHTML('beforeend', egstring);
//               } else {
//                   mobi_maltertech?.insertAdjacentHTML('beforeend', egstring) || mobSel?.insertAdjacentHTML('beforeend', egstring);
//               }
//           }
//       }

//       function observeDOM(selector, callback) {
//           const observer = new MutationObserver(() => {
//               if (document.querySelector(selector)) {
//                   observer.disconnect();
//                   callback();
//               }
//           });

//           observer.observe(document.body, { childList: true, subtree: true });
//       }

//       observeDOM('.page-content .medium-up--three-fifths, .maltertech__product-thumbs', init);
//   } catch (e) {
//       if (debug) console.log(e, "error in Test" + variation_name);
//   }
// })();
